export { getLighthouseMetrics } from './utils/lighthouse-metrics/getLighthouseMetrics';
export { startLighthouseObserver } from './utils/lighthouse-metrics/startLighthouseObserver';
export { getCacheHitRatio } from './utils/cache-hit-ratio';
